import React, { useEffect, useState } from "react";
import Sidebar, { SidebarItem } from "./Sidebar";
import { useSelector } from "react-redux";
import api from "../Axios/api";
import {
  ReceiptText,
  ShoppingBag,
  GitCompare,
  PackageCheck,
  SquareKanban,
  LayoutDashboard,
  FilePenLine,
  IndianRupee,
  Undo2,
  Wallet,
  ShieldPlus,
  Book,
  AlignVerticalJustifyEnd,
  FolderPlus,
  Handshake,
  Trash,
  Blocks,RotateCwFadingClock 
} from "lucide-react";

const SideNav = () => {
  const userId = useSelector((state) => state.user._id);
  const UserName = useSelector((state) => state.user.staff_name);
  const [access, setAccess] = useState([]);
  const [open, setOpen] = useState(false);
  const [openTally, setOpenTally] = useState(false);
  const fetchAccess = async () => {
    try {
      const response = await api.get(`staff/get/${userId}`);
      // console.log("api", response);
      setAccess(response.data[0].subaccessnames);
    } catch (error) {
      console.error("Failed to fetch access data:", error);
    }
  };
  // console.log("data Access", access)

  useEffect(() => {
    const el = document.querySelector(".navList").children;
    fetchAccess();
    for (const iterator of el) {
      iterator.addEventListener("click", function () {
        for (const element of el) {
          element.classList.remove("bg-gradient-to-tr");
          element.classList.remove("from-indigo-200");
          element.classList.remove("to-indigo-100");
          element.classList.remove("text-indigo-800");
        }
        this.classList.add("bg-gradient-to-tr");
        this.classList.add("from-indigo-200");
        this.classList.add("to-indigo-100");
        this.classList.add("text-indigo-800");
      });
    }
  }, []);

  const hasMasterAccess =
    (access.length > 0 &&
      access.some((item) => item.submodulename === "Purchase Master")) ||
    UserName === "Admin";

  const canAddCategory =
    (access.length > 0 &&
      access.some((item) => item.submodulename === "Add Category")) ||
    UserName === "Admin";

  const canAddItems =
    (access.length > 0 &&
      access.some((item) => item.submodulename === "Add Items")) ||
    UserName === "Admin";

  const canAddParty =
    (access.length > 0 &&
      access.some((item) => item.submodulename === "Add Party")) ||
    UserName === "Admin";

  const canDeletePO =
    (access.length > 0 &&
      access.some((item) => item.submodulename === "Deleted PO")) ||
    UserName === "Admin";

  const canPendingPO =
    (access.length > 0 &&
      access.some((item) => item.submodulename === "Pending PO")) ||
    UserName === "Admin";

  const hasConsumptionAccess =
    (access.length > 0 &&
      access.some((item) => item.submodulename === "Consumption")) ||
    UserName === "Admin";

  const hasProductionAccess =
    (access.length > 0 &&
      access.some((item) => item.submodulename === "Production")) ||
    UserName === "Admin";

  const hasProductionReportAccess =
    (access.length > 0 &&
      access.some((item) => item.submodulename === "Purchase Report")) ||
    UserName === "Admin";

  return (
    <Sidebar>
      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Dashboard")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<LayoutDashboard size={20} />}
          text="Dashboard"
          alert
          to="/dashboard"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Summary Report")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<ShoppingBag size={20} />}
          text=" Summary Report"
          to="/summary"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Indent")) ||
        UserName === "Admin") && (
        <SidebarItem icon={<SquareKanban size={20} />} text="Indent" to="/" />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Quotation")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<GitCompare size={20} />}
          text="Quotation Comparison"
          to="/quote-comparison"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Approval List")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<ShoppingBag size={20} />}
          text="Approval List"
          alert
          to="/approval-list"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Created PO")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<PackageCheck size={20} />}
          text="Created Po"
          to="/created-po-list"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Receipt Note")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<ReceiptText size={20} />}
          text="Receipt Note"
          to="/receipt-note-report"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Purchase Entry")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<FilePenLine size={20} />}
          text="Purchase Entry"
          to="/purchase-entry"
        />
      )}
      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Payment")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<IndianRupee size={20} />}
          text="Payment"
          to="/purchase-payment"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Return List")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<Undo2 size={20} />}
          text="Return List"
          to="/returnList"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Material In/Out")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<AlignVerticalJustifyEnd size={20} />}
          text="Material In Out"
          to="/material-in-out"
        />
      )}
      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Opening Stock")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<AlignVerticalJustifyEnd size={20} />}
          text="Opening Stock"
          to="/opening-stock"
        />
      )}
       {((access.length > 0 &&
        access.some((item) => item.submodulename === "New Consumption")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<PackageCheck size={20} />}
          text="New Consumption"
          to="/newConsumption"
        />
      )}
         {((access.length > 0 &&
        access.some((item) => item.submodulename === "Consumption Register")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<PackageCheck size={20} />}
          text="Consumption Register"
          to="/consumptionRegister"
        />
      )}
          {((access.length > 0 &&
        access.some((item) => item.submodulename === "Lot Summary")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<AlignVerticalJustifyEnd size={20} />}
          text="Lot Summary"
          to="/lotSummaryRecord"
        />
      )}
      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Stock Summary Report")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<AlignVerticalJustifyEnd size={20} />}
          text="Stock Summary Report"
          to="/stockSummaryReport"
        />
      )}
        {((access.length > 0 &&
        access.some((item) => item.submodulename === "Lot Summary")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<AlignVerticalJustifyEnd size={20} />}
          text="Stock Register"
          to="/stockRegister"
        />
      )}
          

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "Stock Issue")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<Blocks size={20} />}
          text="Stock Issue"
          to="/stock-issue"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "IT Invoice")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<PackageCheck size={20} />}
          text="IT Invoice"
          to="/computer-invoice-report"
        />
      )}

      {((access.length > 0 &&
        access.some((item) => item.submodulename === "IT Stock")) ||
        UserName === "Admin") && (
        <SidebarItem
          icon={<PackageCheck size={20} />}
          text="Stock History"
          to="/stocks-history"
        />
      )}

      {hasConsumptionAccess && (
        <div>
          {/* Tally Voucher parent */}
          <div onClick={() => setOpenTally(!openTally)}>
            <SidebarItem icon={<Wallet size={20} />} text="Tally Voucher" />
          </div>

          {/* Children */}
          {openTally && (
            <div className="ml-6 flex flex-col gap-1">
              {hasConsumptionAccess && (
                <SidebarItem
                  icon={<FilePenLine size={20} />}
                  text="Consumption-form"
                  to="/consumption-form"
                />
              )}
              {hasProductionAccess && (
                <SidebarItem
                  icon={<FilePenLine size={20} />}
                  text="Production Form"
                  to="/production-form"
                />
              )}

              {hasProductionReportAccess && (
                <SidebarItem
                  icon={<Book size={20} />}
                  text="Report"
                  to="/report"
                />
              )}
            </div>
          )}
        </div>
      )}

      {hasMasterAccess && (
        <div>
          {/* Master parent */}
          <div onClick={() => setOpen(!open)}>
            <SidebarItem icon={<ShieldPlus size={20} />} text="Master" />
          </div>

          {/* Children */}
          {open && (
            <div className="ml-6 flex flex-col gap-1">
              {canAddCategory && (
                <SidebarItem
                  icon={<FolderPlus size={20} />}
                  text="Add Category"
                  to="/add-category"
                />
              )}
              {canAddItems && (
                <SidebarItem
                  icon={<AlignVerticalJustifyEnd size={20} />}
                  text="Add Items"
                  to="/add-items"
                />
              )}
              {canAddParty && (
                <SidebarItem
                  icon={<Handshake size={20} />}
                  text="Add Party"
                  to="/add-party"
                />
              )}

              {canPendingPO && (
                <SidebarItem
                  icon={ <RotateCwFadingClock />}
                  text="Pending Po"
                  to="/pending-po-list"
                />
              )}

              {canDeletePO && (
                <SidebarItem
                  icon={<Trash size={20} />}
                  text="Deleted Po"
                  to="/deleted-po-list"
                />
              )}
            </div>
          )}
        </div>
      )}
    </Sidebar>
  );
};

export default SideNav;
